import { apiInstanceFetch } from "../../../util/api";
import axios from "axios";
import * as ActionType from "./serviceProviderRequest.type";
import { setToast } from "../../../util/toast";

// List pending service provider requests. Backend returns
// { status, data: [...], total, page, limit }.
// The list used to stop at the first 200 rows (page=1&limit=200) with no way to
// reach the rest, while 751 requests existed (2026-09-30). Page through until
// the server's `total` is reached so the table's search + paging cover them all.
let _spReqSeq = 0;
export const getServiceProviderRequest = (status = "pending") => async (dispatch) => {
  const PAGE = 200;
  const seq = ++_spReqSeq; // ignore a slower, older tab switch
  try {
    let all = [];
    for (let page = 1; page <= 100; page++) {
      const res = await apiInstanceFetch.get(
        `serviceProviderRequest?status=${status}&page=${page}&limit=${PAGE}`
      );
      const rows = (res && res.data) || [];
      all = all.concat(rows);
      const total = Number((res && res.total) || 0);
      if (rows.length < PAGE || (total && all.length >= total)) break;
    }
    if (seq !== _spReqSeq) return;
    dispatch({
      type: ActionType.GET_SERVICE_PROVIDER_REQUEST,
      payload: all,
    });
  } catch (error) {
    console.error(error);
  }
};

// Approve. Backend flips User.isServiceProvider = true.
export const acceptServiceProviderRequest = (id) => (dispatch) => {
  axios
    .patch(`serviceProviderRequest/acceptOrNot`, {
      requestId: id,
      decision: "approved",
    })
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.ACCEPT_SERVICE_PROVIDER_REQUEST, payload: id });
        setToast("success", "Service provider approved");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error.message || "request failed"));
};

// Reject with reason. Backend stores reason on the request and keeps
// User.isServiceProvider = false.
export const rejectServiceProviderRequest = (id, reason) => (dispatch) => {
  axios
    .patch(`serviceProviderRequest/acceptOrNot`, {
      requestId: id,
      decision: "rejected",
      reason,
    })
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.REJECT_SERVICE_PROVIDER_REQUEST, payload: id });
        setToast("success", "Service provider request rejected");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error.message || "request failed"));
};
